import { HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, filter, take, switchMap, finalize } from 'rxjs/operators';
import { inject } from '@angular/core';
import { AuthService } from '../service/auth.service';

let isRefreshing = false;
let refreshTokenSubject = new BehaviorSubject<string | null>(null);


export function errorInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError(error => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        // Ako je 401 stigao sa samog auth endpointa (refresh/login/register),
        // NE pokušavaj refreshati ponovno — to bi stvorilo beskonačnu petlju/deadlock.
        // Odmah logout i propagiraj grešku dalje.
        const isAuthEndpoint = req.url.includes('/refreshToken')
          || req.url.includes('/refresh-token')
          || req.url.includes('/login')
          || req.url.includes('/register');

        if (isAuthEndpoint) {
          authService.logout();
          return throwError(() => error);
        }

        return handle401Error(req, next, authService);
      } else {
        return throwError(() => error);
      }
    })
  );
}

function addTokenHeader(request: HttpRequest<unknown>, token: string): HttpRequest<unknown> {
  return request.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });
}

function handle401Error(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
  authService: AuthService
): Observable<HttpEvent<unknown>> {
  if (!isRefreshing) {
    isRefreshing = true;
    refreshTokenSubject.next(null);

    return authService.refreshToken().pipe(
      switchMap((res: any) => {
        const newToken = res?.accessToken || authService.accessToken;
        refreshTokenSubject.next(newToken);

        if (newToken) {
          return next(addTokenHeader(request, newToken));
        }

        authService.logout();
        return throwError(() => new Error('No token after refresh'));
      }),
      catchError((err) => {
        authService.logout();
        refreshTokenSubject.next(null); // otpusti sve koji čekaju, umjesto da ih ostaviš da vise
        return throwError(() => err);
      }),
      finalize(() => {
        isRefreshing = false;
      })
    );
  } else {
    return refreshTokenSubject.pipe(
      filter(token => token !== null),
      take(1),
      switchMap((token) => next(addTokenHeader(request, token!)))
    );
  }
}

